import { FC } from "react";
import type {  BaseFilter } from "src/constants";
import Section from "./FilterLayout/Section";
import { TimeSegments, FacilitiesSelect } from "src/components/Filters";
import RateGroup from "./FilterComponents/RateGroup";

const FILTER_COMPONENTS = {
  TimeSegments: TimeSegments,
  Rating:RateGroup,
  FacilitiesSelect: FacilitiesSelect,
};

export const StaticFilters: FC<{filters:BaseFilter[]; dataGroups?: Map<string, Map<any, any[]>>; isFetching?: boolean}> = ({filters, dataGroups, isFetching}) => {
  return filters.map((filter) => {
    const Component = FILTER_COMPONENTS[filter.component as keyof typeof FILTER_COMPONENTS];
    if (!Component) return null;
    return (
      <Section filterKey={filter.key} label={filter.title} key={filter.key} >
          <Component filter={filter} valuesMap={dataGroups?.get(filter.key)} isFetching={isFetching}/>
      </Section>
    );
  });
};